import { render } from "./MultiSelectField.vue?vue&type=template&id=20af8741"
import script from "./MultiSelectField.vue?vue&type=script&lang=js"
export * from "./MultiSelectField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MultiSelectField.vue"]])

export default __exports__